import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./styles.css";

function PhoneNumberInput({ onChange = () => { }, value }: any) {
  const handlePhoneChange = (value: any) => {
    onChange(value);
  };

  return (
    <PhoneInput
      country={"us"}
      value={value}
      //   className="phoneNumberInputContainer"
      inputProps={{
        className: "phoneNumberInputContainer",
        style: {
          height: "47px",
          width: "100%",
          paddingLeft: "50px"
        },
      }}
      onChange={handlePhoneChange}
      inputStyle={{
        width: "100%",
        borderRadius: "8px",
        borderColor: "#dddfe2",
        // height: "100%",
        border: "1px solid"
      }}
      buttonStyle={{
        borderRadius: "8px 0 0 8px",
        borderColor: "#dddfe2",
        border: "1px solid"
      }}
    />
  );
}

export { PhoneNumberInput };
